import React, { useState, useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faShoppingBag, faTimes, faBars } from "@fortawesome/free-solid-svg-icons";
import logo from "../../Assets/gold.png";
import { useCart } from "../../Context/Cart";
import usericon from "../../Assets/userIcon.png";
import whiteuser from "../../Assets/whiteuser.png";
import Tooltip from "./UserTooltip";
import Fuse from "fuse.js";
import CategorySection from "../Sub_Home/CategorySection";
import "./Navbar.css";

const Navbar = ({ cartCount, textColor }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const [cart] = useCart();
  const navigate = useNavigate();
  const location = useLocation();

  const userIcon = textColor === "white" ? whiteuser : usericon;

  useEffect(() => {
    let lastScrollTop = 0;
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsHidden(scrollTop > lastScrollTop && scrollTop > 100);
      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const authData = sessionStorage.getItem("auth");
    setIsLoggedIn(!!authData);
  }, [location]);

  const handleLogout = () => {
    sessionStorage.removeItem("auth");
    sessionStorage.removeItem("token");
    setIsLoggedIn(false);
    navigate("/login");
  };

  const userLinks = isLoggedIn
    ? [
        { to: "/dashboard/user/profile", label: "Profile" },
        { to: "/dashboard/user/orderhistory", label: "Orders" },
        { to: "/dashboard/user/wishlist", label: "Wishlist" },
        { to: "#", label: "Logout", onClick: handleLogout },
      ]
    : [{ to: "/login", label: "Login" }];

  return (
    <>
      {/* Main Navbar */}
      <header className={`navbar-main ${isHidden ? "hide" : ""}`}>
        <div className="navbar-container">
          {/* Logo */}
          <div className="navbar-logo">
            <NavLink to="/">
              <img src={logo} alt="logo" className="logo-img" />
            </NavLink>
          </div>

          {/* Desktop Navigation */}
          <nav className="navbar-links">
            <NavLink to="/" className="nav-link">HOME</NavLink>
            <NavLink to="/products" className="nav-link">PRODUCTS</NavLink>
          </nav>

          {/* Right Icons */}
          <div className="navbar-icons">
            <Tooltip icon={userIcon} links={userLinks} />
            <NavLink to="/cart" className="cart-icon-wrapper">
              <FontAwesomeIcon icon={faShoppingBag} className="cart-icon" />
              <span className="cart-badge">{cartCount}</span>
            </NavLink>
            <button 
              className="mobile-menu-btn" 
              onClick={() => setSidebarOpen(true)}
            >
              <FontAwesomeIcon icon={faBars} />
            </button>
          </div>
        </div>

        {/* Category Section - Below main navbar */}
        <div className="category-section-wrapper">
          <CategorySection />
        </div>
      </header>

      {/* Mobile Sidebar */}
      <div className={`mobile-sidebar ${sidebarOpen ? "open" : ""}`}>
        <button className="close-btn" onClick={() => setSidebarOpen(false)}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <ul className="sidebar-links">
          <li><NavLink to="/" onClick={() => setSidebarOpen(false)}>HOME</NavLink></li>
          <li><NavLink to="/products" onClick={() => setSidebarOpen(false)}>PRODUCTS</NavLink></li>
          {userLinks.map((link, index) => (
            <li key={index}>
              <NavLink 
                to={link.to} 
                onClick={() => {
                  setSidebarOpen(false);
                  link.onClick?.();
                }}
              >
                {link.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default Navbar;